import { Exclude, Type } from "class-transformer";
import { getSalesManagerItemCategoryI18N } from "../utils/itemcategories";
import { SalesManagerShopItemCategory } from "@impacgroup/ayyildiz-checklist-platform-api-dtos";

export class SalesManagerOrder {
    _id?: string;

    @Type(() => SalesManagerObj)
    salesManager?: SalesManagerObj;
    @Type(() => DistributorObj)
    distributor?: DistributorObj;

    itemCount?: number;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    created: Date;
}

export class SalesmanagerOrderDetails {
    @Type(() => SalesManagerObj)
    salesManager?: SalesManagerObj;
    @Type(() => DistributorObj)
    distributor?: DistributorObj;

    @Type(() => OrderPositionObj)
    orderPositions?: OrderPositionObj;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    created: Date;
}

class SalesManagerObj {
    firstname?: string;
    lastname?: string;
    email?: string;

    public formatUser(): string {
        return `${this.firstname ? `${this.firstname} ` : ""}${this.lastname ? `${this.lastname} ` : ""}${this.firstname || this.lastname ? "\r\n" : ""}${this.email ? `${this.email} ` : ""}`;
    }

    public htmlFormatUser(): string {
        return this.formatUser().replace(/(?:\r\n|\r|\n)/g, "<br />");
    }
}

class DistributorObj {
    vo?: string;
    name?: string;
    street?: string;
    postcode?: string;
    city?: string;

    public formatUser(): string {
        return `${this.vo ? `VO: ${this.vo}\r\n` : ""}${this.name ? `${this.name}\r\n` : ""}${this.street ? `${this.street}\r\n` : ""}${this.postcode ? `${this.postcode} ` : ""}${this.city ? `${this.city}` : ""}`;
    }

    public htmlFormatUser(): string {
        return this.formatUser().replace(/(?:\r\n|\r|\n)/g, "<br />");
    }
}

class OrderPositionObj {
    item?: {
        materialNumber?: string;
        name?: string;
        category?: SalesManagerShopItemCategory;
    };
    quantity?: number;

    public getCategoryI18N(): string {
        return getSalesManagerItemCategoryI18N(this.item.category);
    }
}
